import { Sport } from "../../redux/slices";
import { getBallLabelFromSport } from "../../utils";
import { basketballIcon, puckIcon, soccerBallIcon } from "./icons";

export const getBallIconFromSport = (sport: Sport): string => {
  switch (sport) {
    case Sport.BASKETBALL:
      return basketballIcon;

    case Sport.HOCKEY:
      return puckIcon;

    case Sport.SOCCER:
      return soccerBallIcon;

    case Sport.NO_SPORT:
      throw new Error(`Invalid sport: ${sport}`);
  }
};

export const getToolTipText = (button: string, sport?: Sport): string => {
  switch (button) {
    case "freeDraw":
      return "Draw Action Lines (D)";

    case "sets":
      return "Start with a pre-defined formation";

    case "fastPlace":
      if (sport === Sport.BASKETBALL) {
        return "Place players on court in consecutive clicks (P)";
      } else if (sport === Sport.SOCCER) {
        return "Place players on field in consecutive clicks (P)";
      } else if (sport === Sport.HOCKEY) {
        return "Place players on ice in consecutive clicks (P)";
      }

      return "Place a players in consecutive clicks (P)";

    case "fastBuild":
      return "Advance to new frame";

    case "giveBall":
      if (!sport) throw new Error("Sport is required for giveBall");
      return `Assign selected player the ${getBallLabelFromSport(sport)} (B)`;

    case "undo":
      return "Undo last action (Ctrl + Z)";

    case "redo":
      return "Redo last action (Ctrl + Shift + Z)";

    case "animate":
      return "Open Animation Timeline (A)";

    default:
      throw new Error(`Invalid button: ${button}`);
  }
};
